import { h, render, Component } from 'preact';
import {personManager} from './getPerson';
import {ImageField} from '../display/ImageField';
import {CvField} from '../display/CvField';
import {EmailField} from '../display/EmailField';
import {cookie as cm} from '../storage/cookies';

class Speaker extends Component {
  constructor() {
		super();
		this.pm = null;
		this.state.person = {};
  }
	componentDidMount() {
		const personId = document.getElementById('speaker').dataset.id;
		this.pm = new personManager(personId);

		this.pm.getPerson()
		.getSlug()
		.getAvatar()
		.getBiography({type: "workshop"})
		.getAffiliation();

		// if(cm.hasCookie('workshopVerification')) {
		// 	this.pm.getCV()
		// 	.getEmail();
		// }

		this.pm.execute((err, response) => {
			if(err) console.log(err);
			let person = {}
			response.forEach((obj) => {
				person[obj.key] = obj.response;
			});
			this.setState({ person: person });
		})
	}

	componentWillUnmount() {

	}
	render(props, state) {
		const person = state.person;
		if(Object.keys(person).length === 0) {
			return null;
		}
		const file = (person.avatar && person.avatar[0] && person.avatar[0].file)
		const affiliation = (person.affiliationRelations && person.affiliationRelations[0] && person.affiliationRelations[0].affiliation.label) ? <h3>{person.affiliationRelations[0].affiliation.label}</h3> : null;
		const email = (person.email && person.email[0] && person.email[0].value) ? person.email[0].value : null;
		//const jobtitle = person.person.jobTitle ?  <h3 style='margin-top: 0;'>{person.person.jobTitle}</h3> : null;
		const biography = (person.biographies && person.biographies[0] && person.biographies[0].value) || "<div></div>";
		const cv = (person.cv && person.cv[0] && person.cv[0].file)
		return (
			<div>
				<div id="bio-information" class="uk-clearfix">
					<h2>{person.person.firstName} {person.person.lastName}</h2>
					<ImageField 
						file={file}
					/>
					<div id="bio-summary">
							{affiliation}
							<EmailField email={email} />
							<CvField file={cv} />
					</div>
				</div>
				<div class="biography-proper" dangerouslySetInnerHTML={{ __html: biography }}>
				</div>
			</div>
		);

	}
}

render(<Speaker />, document.getElementById('speaker-render'));